<template>
  <div class="m-auto w-full max-w-4xl border-l-4 border-red-600 bg-red-100 p-4 lg:mr-0 lg:w-2/3">
    <div class="flex">
      <div class="flex-shrink-0">
        <font-awesome-icon
          size="lg"
          class="fatshrink-0 w-5 text-red-600"
          aria-hidden="true"
          :icon="['fal', 'circle-xmark']"
        />
      </div>
      <div class="ml-3">
        <!-- The message is hardcoded, as we cannot possibly get our translations -->
        <p class="text-sm text-red-700">
          Vi beklager, men der ser ud til at være et problem i øjeblikket. Vi kigger på det hurtigst
          muligt. Hvis du oplever problemer, så prøv igen senere.
        </p>
      </div>
    </div>
    <div class="mt-2 flex">
      <div class="h-5 w-5 flex-shrink-0"></div>
      <div class="ml-3">
        <!-- The message is hardcoded, as we cannot possibly get our translations -->
        <p class="text-sm text-red-700">
          We apologize, but there seems to be a problem at the moment. We are looking into it as
          quickly as possible. If you experience any problems, please try again later.
        </p>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts"></script>
